// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/menu/LangMenu.css
// module id = 2009
// module chunks = 0